<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper content-wrapper2">
    <!-- Content Header (Page header) -->
    <nav aria-label="breadcrumb" class="bread">
        <ol class="breadcrumb" style="margin-bottom: 0px;padding: 10px 6.2%;">
          <li  @click="navigate()" class="breadcrumb-item"><a><i class="uil uil-home-alt"></i></a></li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='DashboardV3'">Home</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='ProfileV3'">Profile</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='CandidateDetailsV3'">Candidate Profile</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='SelectInterviewerV3'">Select Interviewer</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='ReportV3'">Report</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='SheduleReportv3'">SheduleReport</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='AdminReportv3'">AdminReport</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='SettingsV3'">Settings</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='AdminSettingsV3'">Admin Settings</li>
          <li class="breadcrumb-item active c-white" v-if="head_name=='OrgDetailsv3'">Organization Details</li>
        </ol>
    </nav>
    <section class="contant">
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
    </section>
  </div>
</template>

<script>
import router from '../../router/index'
export default {
  name: 'va-content-wrap',
  data () {
    return {
      head_name: this.$route.name
    }
  },
  created () {
    this.head_name = this.$route.name
    setInterval(function () {
      this.head_name = this.$route.name
    }.bind(this), 1000)
  },
  methods: {
    navigate () {
      router.push({ name: 'DashboardV3' })
    }
  }
}
</script>

<style>
.bread {
  position: relative;
  width: 100%;
  z-index: 1;
}
.page-enter-active, .page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.page-enter, .page-leave-to {
  opacity: 0;
}
.breadcrumb  {
  background-color: #32373c;
  border-bottom: 0.5px solid #32373c;
}
.breadcrumb.active  {
  color: #fff;
}
.breadcrumb-item.breadcrumb.active {
  color: #fff;
}
a {
    color: #60ab2f;
}
.content {
  min-height: 250px;
  padding: 5px !important;
  margin-right: auto;
  margin-left: auto;
  padding-left: 80px !important;
  padding-right: 80px !important;
  padding-bottom: 18px !important;
}
.content-wrapper {
  margin-top: 55px;
}
</style>
